import { styled } from 'styled-components';

import { styledReset } from '@pkg/primitives';

export const ListButton = styled.button`
    ${styledReset.button}

    color: #FFF;
    font-size: 12px;
    font-weight: 600;
    line-height: 130%;
    letter-spacing: -0.24px;
    white-space: nowrap;

    border-radius: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    user-select: none;

    width: 100%;
    height: 28px;
    margin-right: 12px;

    background: #523df1;

    transition: background-color 0.2s ease-in-out;

    flex-shrink: 0;
    min-width: 100px;

    &:hover {
        background: #6b56ff;
    }

    @media (max-width: 768px) {
        margin: 0;
    }
`;

export const CancelButton = styled.button`
    ${styledReset.button}

    color: #FF004D;
    font-size: 12px;
    font-weight: 600;
    line-height: 130%;
    letter-spacing: -0.24px;
    white-space: nowrap;
    user-select: none;

    border-radius: 100px;
    border: 1px solid #e60256;

    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;

    width: 100%;
    height: 28px;
    margin-right: 12px;

    transition: background-color 0.2s ease-in-out;

    flex-shrink: 0;
    min-width: 100px;

    &:hover {
        background-color: rgba(255, 0, 77, 0.2);
    }

    @media (max-width: 768px) {
        margin: 0;
    }
`;
